import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-arrow-back.svg'
import _imports_1 from '@/assets/icons/icon-plus-white.svg'


const _hoisted_1 = { class: "documents-view" }
const _hoisted_2 = { class: "documents-header" }
const _hoisted_3 = { class: "documents-header--container" }
const _hoisted_4 = { class: "back" }
const _hoisted_5 = { class: "documents-title" }
const _hoisted_6 = { class: "subtitle-main subtitle-main--documents" }
const _hoisted_7 = { class: "menu-option" }
const _hoisted_8 = ["accept"]
const _hoisted_9 = {
  key: 0,
  class: "spinner"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "table-wrapper"
}
const _hoisted_13 = { class: "table-default table--document" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "documents-wrapper-folder" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "documents-wrapper-folder__label" }
const _hoisted_18 = { class: "text-bordered" }
const _hoisted_19 = { class: "menu-wrapper" }
const _hoisted_20 = { class: "wrapper-dots" }
const _hoisted_21 = { class: "menu-option" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "documents-wrapper-folder" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "documents-wrapper-folder__label" }
const _hoisted_27 = { class: "text-bordered" }
const _hoisted_28 = { class: "bold" }
const _hoisted_29 = { class: "menu-wrapper" }
const _hoisted_30 = { class: "wrapper-dots" }
const _hoisted_31 = { class: "menu-option" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "description--highlighted" }
const _hoisted_37 = { class: "description--highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "wrapper-back",
          onClick: $setup.onBack
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_4, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("span", { class: "back-title" }, "Back", -1)
          ]))], 512), [
            [_vShow, $setup.folderPath]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.activeFolder || "Documents"), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(`${$setup.plural($setup.docs.folders.length, "folder")} ${$setup.plural($setup.docs.files.length, "file")}`), 1)
      ]),
      _createVNode($setup["DropDown"], { placement: 'right bottom' }, {
        control: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createElementVNode("button", { class: "button primary button-medium button-add" }, [
            _createElementVNode("div", { class: "button-add--icon" }, [
              _createElementVNode("img", { src: _imports_1 })
            ]),
            _createElementVNode("div", { class: "button-add--text" }, "Add")
          ], -1)
        ]))]),
        dropdown: _withCtx(() => [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("div", {
                class: "menu-item add-folder",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCreateFolder = true))
              }, "Create Folder")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("label", {
                class: "menu-item upload-file",
                for: "upload-file",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, "Upload File")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("input", {
      class: "file-input",
      id: "upload-file",
      type: "file",
      ref: "fileInput",
      onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.uploadFile($event))),
      accept: $setup.documentTypes
    }, null, 40, _hoisted_8),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : ($setup.docs.folders.length + $setup.docs.files.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/documents-slim.svg')
            }, null, 8, _hoisted_11),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, "You don't have any documents yet", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Name"),
                  _createElementVNode("th", { class: "th--last-modified" }, "Created"),
                  _createElementVNode("th", { class: "th--menu" })
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docs.folders, (folder, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    _createElementVNode("td", {
                      class: "column-folder-name bold cursor-pointer",
                      onClick: ($event: any) => ($setup.toFolder(folder.Prefix))
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          class: "folder-icon",
                          src: require(`@/assets/icons/icon-folder.svg`)
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("span", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString($setup.getFolderName(folder.Prefix)), 1)
                      ])
                    ], 8, _hoisted_14),
                    _cache[13] || (_cache[13] = _createElementVNode("td", { class: "bold" }, "-", -1)),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode($setup["DropDown"], { placement: 'right bottom' }, {
                          control: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("div", { class: "dots" }, [
                              _createElementVNode("div", { class: "actions" })
                            ], -1)
                          ]))]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_21, [
                              _createElementVNode("li", null, [
                                _createElementVNode("div", {
                                  class: "menu-item delete",
                                  onClick: ($event: any) => ($setup.showDeleteFileModal(folder.Prefix, idx))
                                }, "Delete Folder", 8, _hoisted_22)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docs.files, (file, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    _createElementVNode("td", {
                      class: "column-folderName bold cursor-pointer",
                      onClick: ($event: any) => ($setup.openFile(file))
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("img", {
                          class: "documents-image-preview",
                          src: $setup.previewIcon(file.Link, file?.Key)
                        }, null, 8, _hoisted_25)
                      ]),
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString($setup.getFileName(file.Key)), 1)
                      ])
                    ], 8, _hoisted_23),
                    _createElementVNode("td", _hoisted_28, _toDisplayString($setup.formatDate(file.LastModified)), 1),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode($setup["DropDown"], {
                          placement: idx < $setup.docs.files.length - 2 ? 'right bottom' : 'right top'
                        }, {
                          control: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("div", { class: "dots" }, [
                              _createElementVNode("div", { class: "actions" })
                            ], -1)
                          ]))]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_31, [
                              _createElementVNode("li", {
                                onClick: ($event: any) => ($setup.showDeleteFileModal(file.Key, idx))
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("div", { class: "menu-item delete" }, "Delete File", -1)
                              ]))], 8, _hoisted_32),
                              _createElementVNode("li", {
                                onClick: ($event: any) => ($setup.downloadFile(file.Key, $setup.estateId))
                              }, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("div", { class: "menu-item upload-file" }, "Download File", -1)
                              ]))], 8, _hoisted_33),
                              _createElementVNode("li", {
                                onClick: ($event: any) => ($setup.shareFile(file))
                              }, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("div", { class: "menu-item share" }, "Share File with lots", -1)
                              ]))], 8, _hoisted_34),
                              _createElementVNode("li", {
                                onClick: ($event: any) => ($setup.shareFileWithStage(file))
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("div", { class: "menu-item share" }, "Share File with Stage", -1)
                              ]))], 8, _hoisted_35)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["placement"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode($setup["RemoveDocumentsModal"], {
              isOpen: $setup.isOpenRemoveDocumentsModal,
              onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.isOpenRemoveDocumentsModal = false)),
              onConfirm: $setup.deleteFile
            }, {
              title: _withCtx(() => [
                _createElementVNode("span", _hoisted_36, "Confirm " + _toDisplayString($setup.getRemoveDocumentType) + " removal", 1)
              ]),
              description: _withCtx(() => [
                _createTextVNode("Are you sure you want to delete " + _toDisplayString($setup.getRemoveDocumentType) + " '", 1),
                _createElementVNode("span", _hoisted_37, _toDisplayString($setup.getRemoveDocumentType === "folder" ? $setup.getFolderName($setup.fileForDelete.file) : $setup.getFileName($setup.fileForDelete.file)) + "'", 1),
                _createTextVNode(_toDisplayString($setup.getRemoveDocumentType === "folder" ? " and all files in it?" : "?"), 1)
              ]),
              _: 1
            }, 8, ["isOpen"])
          ])),
    _createVNode($setup["CreateFolderModal"], {
      isOpen: $setup.showCreateFolder,
      folderPath: $setup.folderPath,
      estateId: $setup.estateId,
      onUpdate: _cache[4] || (_cache[4] = ($event: any) => ($setup.addFolder($event))),
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.showCreateFolder = false))
    }, null, 8, ["isOpen", "folderPath", "estateId"]),
    _createVNode($setup["ImagePreviewModal"], {
      showImg: $setup.showImg,
      onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.showImg = undefined))
    }, null, 8, ["showImg"]),
    _createVNode($setup["ShareLotsModal"], {
      isOpen: $setup.showShareModal,
      fileData: $setup.fileToShare,
      type: 'document',
      estateId: $setup.estateId,
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.showShareModal = false))
    }, null, 8, ["isOpen", "fileData", "estateId"]),
    _createVNode($setup["ShareStageModal"], {
      isOpen: $setup.showShareStageModal,
      fileData: $setup.fileToShare,
      estateId: $setup.estateId,
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.showShareStageModal = false))
    }, null, 8, ["isOpen", "fileData", "estateId"])
  ]))
}